import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box, Text } from 'rebass';
import WebcamRecordVideo from './RecordVideo';
import Modal from 'app/modal/v3';
import VideoPreview from './VideoPreview';
import { IoVideocamOutline } from "react-icons/io5";

const RecordChatButton = ({ onRecordChat, isFromRecordVideo, handleChange }) => {
  const [loading, setLoading] = useState(false);
  const [videoTime, setVideoTime] = useState(null);
  const [file, setFile] = useState(null);
  const [startRecording, setStartRecording] = useState(false);
  const handleClick = async () => {
    if (isFromRecordVideo) {
      setStartRecording(true)
      return
    }
    setLoading(true);
    onRecordChat();
  };


  return (<>
    {startRecording && <Modal
      close={{ onClose: () => setStartRecording(false) }}
      maxWidth={800}
      title={"Record Your Video"}
      closeOnOutsideClick={false}
      aboveTooltip
    >
      {file ?
        <VideoPreview
          videoTime={videoTime}
          blob={file}
          onReject={() => setFile(undefined)}
          onAccept={() => {
            const newFile = new File([file], file.name, { type: file.type, lastModified: Date.now() });
            setStartRecording(false)
            handleChange({ target: { files: [newFile] } }, true)
          }}
          minHeight={360}
          height="auto"
          width={['100vw', '640px', '800px']}
        // mt={-80}
        />
        : <WebcamRecordVideo setVideoTime={setVideoTime} onEnded={(blob) => setFile(blob)} />}
    </Modal>}

    <Flex sx={{ cursor: loading ? 'not-allowed' : 'pointer' }} disabled={loading} onClick={handleClick} justifyContent="space-between" width="100%" alignItems="center">
      <Flex alignItems="center">
        <Flex height="max-content" mr={1} justifyContent="center" alignItems="center" bg="#EFFFF5" p="14px" sx={{ borderRadius: '50%' }}>
          <Box as={IoVideocamOutline} color="#2E9E58" minWidth={24} size={24} />
        </Flex>
        <Text fontFamily="Poppins" fontSize={18} lineHeight="165%" fontWeight={500} color="#0E0E0E" >
          Video Recording
        </Text>
      </Flex>
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">
        <path d="M0.514648 2.34292L1.92885 0.928711L8.99995 7.99975L1.92885 15.0709L0.514648 13.6567L6.17155 7.99975L0.514648 2.34292Z" fill="#64748B" />
      </svg>
    </Flex>
  </>
  );
};

RecordChatButton.propTypes = {
  onRecordChat: PropTypes.func.isRequired,
};

RecordChatButton.defaultProps = {
  onRecordChat: () => { },
};

export default RecordChatButton;
